module.exports = __webpack_public_path__ + "static/sword_of_kas-10e63a407bbd6066ddb5444369e942ee.jpeg";